/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { OfferingType } from "./OfferingType";
import { LicenseRenewal } from "./LicenseRenewal";
import { PaymentDto } from "./PaymentDto";

export class LicenseDto {
    id: string;
    organisationId: string;
    offeringType: OfferingType;
    licenseRenewal: LicenseRenewal;
    paymentDto: PaymentDto;
    paymentId: string | null;
    isActivated: boolean;
    licensedUntil: Date | null;
    chargeAutomatically: boolean;
}
